module.exports = __webpack_public_path__ + "img/icon_m.bcff0acb.png";